import React, { Component, useEffect, useState } from 'react';
import configData from '../../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import Select from 'react-select';
import { toDate } from 'date-fns';
import SelectSearch, { fuzzySearch } from "react-select-search";
import DatePicker from 'react-date-picker';
import moment from 'moment';

import "../../style/select-search.css";
import { isDisabled } from '@testing-library/user-event/dist/utils';

export default function SettingsRightFilterContent(props) {

    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    const defaultFromValue = moment(fromDate).format().substring(0, 10);
    const defaultToValue = moment(toDate).format().substring(0, 10);

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [divisions, setDivision] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [selectedCust, setSelectedCust] = useState(0);
    const [selectedDivision, setSelectedDivision] = useState(0);
    const [selectedProNumber, setSelectedFb] = useState('');
    const [selectedAccountNumber, setSelectedAccountNumber] = useState('');
    const [selectedFromDate, setSelectedFromDate] = useState(moment(fromDate).format().substring(0, 10));
    const [selectedToDate, setSelectedToDate] = useState(moment(toDate).format().substring(0, 10));
    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);
    const [divisionLoading, isDivisionLoading] = useState(false);



    const [selectedPastNumOfWeek, setSelectedPastNumOfWeek] = useState(20);
    const [selectedImmediatePastNumWeek, setSelectedImmediatePastNumWeek] = useState(3);
    const [selectedPercentageDecrease, setSelectedPercentageDecrease] = useState(20);
    const [selectedPercentageIncrease, setSelectedPercentageIncrease] = useState(20);

    const [selectedAccountNumberWithNoInvoice, setAccountNumberWithNoInvoice] = useState(false);

    const [value, setValue] = useState("");

    const LoadOwners = async () => {
        // debugger;
        isOwnerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const own = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, own];
                })
                const defaultOwner = {
                    "name": "--ALL OWNERS--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomer(0);

        // setIsDisabled(props.isDisabled);
    }

    const LoadCustomer = async (ownerKey) => {
        // debugger;
        setSelectedOwner(ownerKey);
        isDivisionLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--ALL CUSTOMERS--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isDivisionLoading(false);
        // setIsDisabled(props.isDisabled);
    }

    const selectFromDate = (e) => {
        debugger;
        var today = new Date();
        if (e > today) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fed-error").innerHTML = "From Entry Date is greater than Current Date";
            document.getElementById("fed-highlight").innerHTML = "*&nbsp&nbsp";
            // return;
        }
        else if (e > toDate) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fed-error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("fed-highlight").innerHTML = "*&nbsp&nbsp";
            // return;
        }
        else {
            document.getElementById("fed-error").innerHTML = "";
            document.getElementById("fed-highlight").innerHTML = "";
        }
        setFromDate(e);
        setSelectedFromDate(moment(e).format().substring(0, 10))

    };

    const selectToDate = (e) => {
        // debugger;

        // var toDateString = e.toLocaleDateString();
        // const afterLastSlash = toDateString.substring(toDateString.lastIndexOf('/') + 1)
        // console.log(afterLastSlash);

        // if (afterLastSlash.length === 4) {
        // }

        var today = new Date();
        if (e > today) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("ted-error").innerHTML = "To Entry Date is greater than Current Date";
            document.getElementById("ted-highlight").innerHTML = "*&nbsp&nbsp";
            // return;
        }
        else if (e < fromDate) {
            // document.getElementById("error").innerHTML = "From Entry Date is greater than To Entry Date";
            document.getElementById("ted-error").innerHTML = "To Entry Date is less than From Entry Date";
            document.getElementById("ted-highlight").innerHTML = "*&nbsp&nbsp";
            // return;
        }
        else {
            document.getElementById("ted-error").innerHTML = "";
            document.getElementById("ted-highlight").innerHTML = "";
        }
        setToDate(e);
        setSelectedToDate(moment(e).format().substring(0, 10))


    };

    const LoadBills = async (e) => {
        debugger;
        e.preventDefault();
        if (props.dateDivVisible === false) {
            props.onSearchClick(selectedOwner, selectedCust);
        }
        else
        {
            var today = new Date();
            var myFromdate = new Date(selectedFromDate);
            // console.log(today.toDateString());
            // console.log(myfromdate.toDateString());
            if (myFromdate.toString() == 'Invalid Date') {
                document.getElementById("fed-error").innerHTML = 'Invalid Date'
                return;
            }
    
    
            if (myFromdate > today) {
                console.log(selectedFromDate);
                return;
            }
    
            var myTodate = new Date(selectedToDate);
    
            if (myTodate.toString() == 'Invalid Date') {
                document.getElementById("ted-error").innerHTML = 'Invalid Date'
                return;
            }
    
            if (myTodate > today) {
                console.log(selectedToDate);
                return;
            }
    
            if (myFromdate > myTodate) {
                return;
            }
    
            props.onSearchClick(selectedOwner, selectedCust, selectedFromDate, selectedToDate);
        }
    }

    useEffect(() => {
        debugger;
        LoadOwners();
        // LoadCustomer();
        // const inputPstNoOfwk = document.querySelector('#pastnumofweek');
    }, [])

    const onOwnerSelect = (e) => {
        // debugger;
        var ownerkey = e;
        if (ownerkey > 0) {
            document.getElementById("owner-error").innerHTML = "";
            document.getElementById("owner-highlight").innerHTML = "";
        }
        LoadCustomer(e);
        setSelectedCust(0);
        // props.onCustomerChange(custkey);

    };

    const onCustomerSelect = (e) => {
        var custkey = e;
        if (custkey > 0) {
            document.getElementById("customer-error").innerHTML = "";
            document.getElementById("customer-highlight").innerHTML = "";
        }
        setSelectedCust(custkey);
    };
 

    const ClearFilter = async (e) => {
        // debugger;
        e.preventDefault();
        setSelectedOwner(0);
        setSelectedCust(0);

        let customerOptions = [];
        const defaultCustomer = {
            "name": "-- ALL CUSTOMERS --",
            "value": 0
        }
        customerOptions.unshift(defaultCustomer);
        setCustomers(customerOptions);

        setToDate(new Date());
        setFromDate(new Date(new Date().getFullYear(), 0, 1, 23, 59, 59));
    }

  


    return (
        <>
            <div className="mb-2 form-field">
                <div id="owner-error" className="text-danger"></div>
                <label><label id="owner-highlight" className="text-danger"></label>Owner</label>
                <div>
                    {/* <select id="ddnCustomer" name="ddnCustomer" className='form-select form-select-sm' onChange={onCustomerSelect}>
                        <option value="-1">--Select A Value--</option>
                        {customers.map((data, index) => {
                            return <option key={data.customerKey} value={data.customerKey}>{data.customerName}</option>
                        })}
                    </select> */}
                    <SelectSearch
                        id="ddnOwner"
                        name="ddnOwner"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedOwner}
                        options={owners}
                        onChange={onOwnerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {ownerLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : ownerLoading}
            </div>
            <div className="mb-3 form-field">
                <div id="customer-error" className="text-danger"></div>
                <label><label id="customer-highlight" className="text-danger"></label>Customer</label>
                <div>
                    <SelectSearch
                        id="ddnCustomer"
                        name="ddnCustomer"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedCust}
                        options={customers}
                        onChange={onCustomerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {divisionLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : divisionLoading}
            </div>
            {props.dateDivVisible && ( // Add this conditional wrapper
                <>
                    <div className="mb-2 form-field">
                        <div id="fed-error" className="text-danger"></div>
                        <label><label id="fed-highlight" className="text-danger"></label>From Entry Date</label>
                        <div>
                            <DatePicker
                                value={fromDate}
                                onChange={selectFromDate}
                                calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                format="MM/dd/yyyy"
                                fixedHeight
                            />
                        </div>
                    </div>
                    <div className="mb-2 form-field">
                        <div id="ted-error" className="text-danger"></div>
                        <label><label id="ted-highlight" className="text-danger"></label>To Entry Date</label>
                        <div>
                            <DatePicker
                                value={toDate}
                                onChange={selectToDate}
                                calendarIcon={<i className='fas fa-calendar-alt'></i>}
                                format="MM/dd/yyyy"
                                fixedHeight
                            />
                        </div>
                    </div>
                </>
            )}
            <div className="form-field mx-auto" style={{ width: "180px" }}>
                <button type="button" onClick={ClearFilter} className='btn btn-clear'>Clear</button>
                <button type="button" onClick={LoadBills} className='btn btn-filter ms-2'>Filter</button>
            </div>
        </>
    )
}
